import React from 'react';

const QuoteLink = props => (
  <div className="mb-3 custom-quote-link-wrap d-grid">
    <a
      href={Spree.routes.custom_quote_request_new_url}
      className={props.buttonClassName}>CUSTOM QUOTE
    </a>
  </div>
);

const Title = (props) => {
  if (!props.title) return null;

  return (<h6 className="title">{props.title}</h6>);
};

const CustomQuote = props => (
  <div className="row">
    <div className="col-md-6">
      {props.buttonTop ? <QuoteLink {...props} /> : null}
    </div>
    <div className="col-md-12 mb-2">
      <Title title={props.title} />
      {props.label}
    </div>
    {props.children}
    <div className="col-12">
      {props.buttonBottom ? <QuoteLink {...props} /> : null}
    </div>
  </div>

);

CustomQuote.defaultProps = {
  label          : 'Get a Custom Quote if you don\'t know the board specs or if the board has any of the following:',
  buttonTop      : true,
  buttonBottom   : false,
  buttonClassName: 'btn btn-block btn-primary',
};

export default CustomQuote;
